(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const enhanceMegaMenu = (details) => {
    let closeTimer;

    const open = () => {
      if (!finePointer.matches) return;
      window.clearTimeout(closeTimer);
      details.open = true;
      details.setAttribute('data-hover-open', '');
    };

    const close = () => {
      if (!finePointer.matches) return;
      closeTimer = window.setTimeout(() => {
        details.open = false;
        details.removeAttribute('data-hover-open');
      }, 140);
    };

    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', close);
    details.addEventListener('focusin', () => {
      window.clearTimeout(closeTimer);
      details.open = true;
    });
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) close();
    });
  };

  const init = () => document.querySelectorAll('[data-catalog-mega]').forEach(enhanceMegaMenu);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
